export const columnsForExport = [
  { label: "Facility", key: "facility_name" },
  { label: "District", key: "district_name" },
  { label: "Block", key: "block_name" },
  { label: "Created on", key: "created_on" },
  { label: "Open Date", key: "open_date" },
  { label: "Status", key: "open_status" },
  { label: "Close Date", key: "close_date" },
  { label: "Breakfast", key: "breakfast" },
  { label: "Lunch", key: "lunch" },
  { label: "Dinner", key: "dinner" },
  { label: "Total Meals", key: "total_meals" },
];
